module.exports = __webpack_public_path__ + "img/7.4358711b.jpg";